import { render, staticRenderFns } from "./releaseAgent.vue?vue&type=template&id=640f27c0&scoped=true&"
import script from "./releaseAgent.vue?vue&type=script&lang=js&"
export * from "./releaseAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f27c0",
  null
  
)

export default component.exports